import { createReducer } from '@ngrx/store';
import { initialState } from './state';

export const notificationFeatureReducer = createReducer(initialState);
